module.exports = __webpack_public_path__ + "img/right_ring.48304912.png";